import styled from '@emotion/styled'
import DownloadIconButton from 'UI/DownloadIconButton'
import SyncIconButton from 'UI/SyncIconButton'
import TableContainer from '../../UI/TableContainer'

export const AdditionalElementContainer = styled.div`
  display: flex;
`

export const StyledDownloadIconButton = styled(DownloadIconButton)`
  margin: 0 20px 0 30px;
`

export const StyledSyncIconButton = styled(SyncIconButton)`
  margin-right: 14px;
`

export const StyledTableContainer = styled(TableContainer)<{ show: boolean }>`
  display: ${({ show }) => (!show ? 'none' : 'block')};
`
